import { postMethod } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const CREATE_PASSWORD_SUCCESS = 'CREATE_PASSWORD_SUCCESS';
export const CREATE_PASSWORD_FAILURE = 'CREATE_PASSWORD_FAILURE';

// Action Creators
export const fetchCreatePassword = () => ({
  type: CREATE_PASSWORD,
});

export const fetchCreatePasswordSuccess = (data) => ({
  type: CREATE_PASSWORD_SUCCESS,
  payload: data,
});

export const fetchCreatePasswordFailure = (error) => ({
  type: CREATE_PASSWORD_FAILURE,
  payload: error,
});

// Thunk Function
export const createPasswordCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchCreatePassword(data, external));
    try {
      const response = await postMethod(url.createPasswordProviderAdmin, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchCreatePasswordSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchCreatePasswordFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchCreatePasswordFailure(error.message));
    }
  };
};
